import { useState } from "react";
import styles from "~/styles/burn-rate.module.css";

interface HeroDisplayProps {
  primaryLabel: string;
  netPrice: string;
  clientPays: string;
  youReceive: string;
  profit: string;
  sym: string;
}

export function HeroDisplay({
  primaryLabel,
  netPrice,
  clientPays,
  youReceive,
  profit,
  sym,
}: HeroDisplayProps) {
  const [activePill, setActivePill] = useState<"net" | "client" | "receive">("net");

  const pills = [
    { key: "net" as const, label: "Precio neto", value: netPrice },
    { key: "client" as const, label: "Cliente paga", value: clientPays },
    { key: "receive" as const, label: "Tú recibes", value: youReceive },
  ];

  const activeValue = pills.find((p) => p.key === activePill)?.value ?? netPrice;
  const activeLabel = pills.find((p) => p.key === activePill)?.label ?? primaryLabel;

  return (
    <div className={styles.heroDisplay}>
      <p className={styles.heroLabel}>{activeLabel}</p>
      <p className={styles.heroValue}>
        <span className={styles.heroSym}>{sym}</span>
        {activeValue}
      </p>
      <div className={styles.heroPills}>
        {pills.map((p) => (
          <button
            key={p.key}
            className={`${styles.heroPill} ${activePill === p.key ? styles.heroPillActive : ""}`}
            onClick={() => setActivePill(p.key)}
          >
            <span className={styles.heroPillLabel}>{p.label}</span>
            <span className={styles.heroPillValue}>
              {sym}{p.value}
            </span>
          </button>
        ))}
      </div>
      <div className={styles.heroProfit}>
        <span className={styles.heroProfitLabel}>Ganancia</span>
        <span className={styles.heroProfitValue}>{sym}{profit}</span>
      </div>
    </div>
  );
}
